import { render, staticRenderFns } from "./bindCellphone.vue?vue&type=template&id=19b57ee1"
import script from "./bindCellphone.vue?vue&type=script&lang=js"
export * from "./bindCellphone.vue?vue&type=script&lang=js"
import style0 from "./bindCellphone.vue?vue&type=style&index=0&id=19b57ee1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports